import React, { useEffect, useState } from 'react';
import { Box, Text, Heading, Flex, Image, Checkbox, Stack, Circle, Button } from '@chakra-ui/react';
import companiesIcon from '../../Assets/Icons/companiesIcons.svg';
import Vector1 from '../../Assets/Icons/Vector1.svg';
import { useAllCourses } from '../../../../hooks/V2/useCourse';
import { set } from 'mongoose';
import { useUserProfile } from '../../../../hooks/useUser';
import { CoreSectorPossibleRoles } from '../../Onboarding/CollegeInformation';

export interface Course {
	id: string;
	courseName: string;
	possibleRoles: string[];
	averageCTC: string;
	isUpcomming: boolean;
	companyLogo?: string;
}

interface Props {
	selectedCourses: Course[];
	setSelectedCourses: (selectedCourses: Course[]) => void;
}

const AspireCareer = ({ selectedCourses, setSelectedCourses }: Props) => {
	const { data: allCourses } = useAllCourses();
	const [coursesFormattedData, setCoursesFormattedData] = useState<Course[]>([]);
	const { data: userProfile } = useUserProfile();
	useEffect(() => {
		if (!allCourses) {
			return;
		}

		const formattedData = allCourses?.map(course => {
			return {
				id: course._id,
				courseName: course.name === 'Core Sector' ? userProfile?.branch : course?.name,
				// @ts-ignore
				possibleRoles: course.name === 'Core Sector' ? CoreSectorPossibleRoles[userProfile?.branch] || ['Others'] : course?.meta?.possibleRoles || [],
				// @ts-ignore
				averageCTC: course?.meta?.averageCtc || '',
				// @ts-ignore
				isUpcomming: !course.isActive,
				// @ts-ignore
				companyLogo: course?.meta?.companyLogoUrl || '',
			};
		});

		setCoursesFormattedData(formattedData);
	}, [allCourses]);

	const initialCheckedItems: Record<string, boolean> = coursesFormattedData.reduce<Record<string, boolean>>((acc, career) => {
		acc[career.id] = false;
		return acc;
	}, {});

	const [checkedItems, setCheckedItems] = useState<Record<string, boolean>>(initialCheckedItems);

	const handleCheckboxChange = (id: string) => {
		const updatedCheck = { ...checkedItems, [id]: !checkedItems[id] };
		setCheckedItems(updatedCheck);

		const checkedCareer = coursesFormattedData.find(career => career.id === id);

		if (checkedCareer) {
			if (updatedCheck[id]) {
				// If checkbox is checked
				// @ts-ignore
				setSelectedCourses(prev => [...prev, checkedCareer]);
			} else {
				// If checkbox is unchecked
				// @ts-ignore
				setSelectedCourses(prev => prev.filter(career => career.id !== id));
			}
		}
	};

	useEffect(() => {
		console.log('Selected Careers:', selectedCourses);
	}, [selectedCourses]);

	return (
		<Box position="relative" zIndex={0}>
			<Box
				overflowY="auto"
				display={'grid'}
				gridTemplateColumns={['repeat(1,1fr)', 'repeat(2,1fr)']}
				gap={{ base: '12px', md: '32px' }}
				m={'auto'}
				mt={4}
				overflow={'visible'}
				// w={['95%', '90%', '80%', '70%', '70%']}
			>
				{coursesFormattedData.map(el => (
					<Box
						p={3}
						cursor={'pointer'}
						borderRadius={'15px'}
						overflow={'visible'}
						bg={checkedItems[el.id] ? '#F2F6FF' : el.isUpcomming ? '#F3F2F2' : 'white'}
						borderColor={checkedItems[el.id] ? '#4358F6' : '1px solid grey.200'}
						borderWidth={'1.6px'}
						// position={'relative'}
						onClick={() => {
							if (!el.isUpcomming) {
								handleCheckboxChange(el.id);
							}
						}}
					>
						<Flex mb={'6px'} justify="space-between" align="center">
							<Text textStyle={'h5'} color={'#3B3435'} fontWeight={600}>
								{el.courseName}
							</Text>
							{el.isUpcomming ? (
								<Flex
									alignItems={'end'}
									// position={'absolute'}
									// right={'-1.2rem'}
									mr={'-22px'}
								>
									<Text
										bg="#F5F0FF"
										letterSpacing={'1.25px'}
										lineHeight={'24px'}
										fontSize={'14px'}
										px="8px"
										textStyle="btn-md"
										fontWeight={'700'}
										color={'#7261DF'}
										py="4px"
										borderTopRadius={'8px'}
									>
										Coming soon
									</Text>
									{/* <Image src={Vector1} alt="vector" /> */}
								</Flex>
							) : (
								<Checkbox
									size="lg"
									pointerEvents="none"
									style={{ borderColor: '#848081' }}
									isChecked={checkedItems[el.id]}
									colorScheme="messenger"
									// onChange={() => handleCheckboxChange(el.id)}
								/>
							)}
						</Flex>

						<Box mb={2}>
							<Text textStyle={'caption'}>Possible Roles:</Text>
							{
								// @ts-ignore
								<Text textStyle={'body2-md'} fontSize={'12px'} lineHeight={'16px'}>
									{el?.possibleRoles.join(', ')}
								</Text>
							}
						</Box>

						<hr />

						<Flex mt={2} justify="space-between" align="center">
							<Stack fontWeight={'bold'} direction="column" spacing={1}>
								<Text textStyle={'caption'}>Average CTC:</Text>

								<Text textStyle={'h4'} color="#4358F6">
									{el.averageCTC}
								</Text>
							</Stack>
							<Image src={el?.companyLogo} alt="company-logo" objectFit="cover" />
						</Flex>
					</Box>
				))}
			</Box>
		</Box>
	);
};

export default AspireCareer;
